import React from "react";
import { Grid, Typography } from "@mui/material";
import ContentCard from "../../components/content-card";
import ContactCard from "../../components/contact-card";
import { i18n } from "../../translate/i18n";
import SaveHistory from "../../functions/save-history";

/**
 * @param {React.Key | null | undefined} index
 * @param {any} setor
 * @param {any} title
 * @param {any} subtitle
 * @param {any} link
 * @param {any} icon
 * @param {any} img
 * @param {boolean} highlight
 * @param {boolean} boolean
 * @param {any} department
 */
function isHighlight(
  index,
  setor,
  title,
  subtitle,
  link,
  icon,
  img,
  highlight,
  boolean,
  department,
  children,
  id
) {
  if (highlight && boolean && setor === department && children.length !== 0) {
    return (
      <Grid item xs={12} sm={6} lg={3}>
        <ContentCard
          key={index}
          title={title}
          subtitle={subtitle}
          link={link}
          icon={icon}
          img={img}
        ></ContentCard>
      </Grid>
    );
  } else if (highlight && boolean && setor === department && children.length === 0) {
    return (
      <Grid item xs={12} sm={6} lg={3}>
        <ContentCard
          key={index}
          title={title}
          subtitle={subtitle}
          link={link}
          icon={icon}
          img={img}
          handleClick={() => SaveHistory(id)}
        ></ContentCard>
      </Grid>
    );
  } else if (highlight === false && boolean === false && setor === department) {
    return (
      <Grid item xs={12} sm={6} lg={4}>
        <ContactCard
          key={index}
          title={title}
          link={link}
        ></ContactCard>
      </Grid>
    );
  }
}

function TemplateForms(department, content) {
  return (
    <Grid container gap={2} direction={"column"}>
      <Typography variant="h5">{i18n.t("forms.access_forms")}</Typography>
      <Grid container spacing={2}>
        {content.map((dict, index) =>
          isHighlight(
            index,
            dict.setor,
            dict.title,
            dict.subtitle,
            dict.link,
            dict.icon,
            dict.img,
            dict.highlight,
            true,
            department.department,
            dict.children,
            dict.id
          )
        )}
      </Grid>
    </Grid>
  )
}

export default TemplateForms;
